// extracted by mini-css-extract-plugin
export default {"Container":"Clothing_Container__gdcoE"};